import { render, staticRenderFns } from "./MaintenanceBanner.vue?vue&type=template&id=2231a4a5&scoped=true&"
import script from "./MaintenanceBanner.vue?vue&type=script&lang=js&"
export * from "./MaintenanceBanner.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceBanner.vue?vue&type=style&index=0&id=2231a4a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231a4a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
